import React, { Component } from 'react';
import { Container, Row, Col,
  Button,  FormGroup,  FormText } from 'reactstrap';
import { Field } from 'redux-form'


import {renderInput, renderInputUpperCase} from '../../utils/forms/renderers'
import { isRequired, isEmail, minLength, exactLength} from '../../utils/forms/validators'

import { ButtonLoader } from '../../utils/loader'

import '../styles/style.css';


class RegisterForm extends Component {
    constructor(props) { 
        super(props);
        this.state={}
    }

   componentDidMount() {
      this.props.listRegion()
   }

   render() {
        const { handleSubmit, user } = this.props;

        return (
            <Container className="form-register">
                <div className="form-container">
                  <form role="form" onSubmit={handleSubmit}>
                      <Row>
                        <Col xs="12" sm="6">
                          <Field
                            name="last_name"
                            component={renderInputUpperCase}
                            validate={isRequired}
                            label="Nom*" />
                        </Col>

                        <Col xs="12" sm="6">
                            <Field
                              name="first_name"
                              component={renderInputUpperCase}
                              validate={isRequired}
                              label="Prénom*" />
                        </Col>
                      </Row>

                      
                      <Row>
                          <Col>
                            <Field
                              type="email"
                              name="username"
                              component={renderInput}
                              validate={[isRequired, isEmail]}
                              label="Email*" />
                          </Col>
                      </Row>

                      <Row>
                          <Col>
                            <Field
                              name="password"
                              type="password"
                              component={renderInput}
                              validate={[isRequired, minLength(6)]}
                              label="Mot de passe*" />
                          </Col>
                      </Row>

                      <Row>
                          <Col>
                            <Field
                              name="confirm_password"
                              type="password"
                              component={renderInput}
                              validate={[isRequired]}
                              label="Confirmation mot de passe*" />
                          </Col>
                      </Row>

                      <Row>
                          <Col>
                            <Field
                              name="phone"
                              component={renderInput}
                              validate={[isRequired, exactLength(10)]}
                              maxlength="10"
                              label="Téléphone*" />
                          </Col>
                      </Row>

                       <Row>
                        <Col className="center">

                          {user.pending && 
                            <ButtonLoader /> 
                          ||
                            <FormGroup>
                                <Button className="btn-green">Créer un compte</Button>
                            </FormGroup>
                          }
                        </Col>
                      </Row>

                      <Row>
                        <Col>
                            <FormText>* Champs obligatoires</FormText>
                            <FormText>La création d’un compte prestataire est gratuite et est ouverte à tout prestataire qui souhaite rejoindre le réseau de prestataire agréé d’HomeServe.
                                Pour créer son compte prestataire, le prestataire doit renseigner le présent formulaire et choisir un mot de passe personnel.
                                En remplissant le formulaire, le prestataire s’engage à le compléter de bonne foi, en fournissant des informations exactes. Il s’engage à ne pas usurper d’identité et à maintenir confidentiel son mot de passe.
                                Le Prestataire s’interdit d’utiliser son compte prestataire à des fins contraires à la loi et notamment en saisissant ou téléchargeant des contenus à caractère violent, diffamatoire ou illicite ou encore en mettant en cause notre sécurité informatique (notamment par l’introduction de virus, code malveillant ou autre technologie nuisible).
                                HomeServe se réserve la possibilité de modifier à tout moment les services proposés par le Site et fera ses meilleurs efforts pour permettre l’accessibilité au Site.</FormText>
                        </Col>
                      </Row>
                   </form> 
                </div>
            </Container>
        )
    }
}

export default RegisterForm


// WEBPACK FOOTER //
// ./src/user/components/RegisterForm.js